import loadable from '@loadable/component'

export default {
    '/:type/mall/recruit/:modal': loadable(() => import('./Home'))
}